import { useCallback, useState } from 'react';
import { useI18n } from '@/hooks/useI18n';
import { buttonClass } from '@/components/ui/Button';
import { useSesion } from './useSesion';
import styles from '../area.module.css';

/**
 * Quién está dentro, y el botón para salir.
 *
 * Vive en un componente y no repetido en cada pantalla porque lo usan las dos
 * del área —el panel y la de administración— y ya estaban repitiendo la línea
 * de «entraste como…». Dos copias de algo que se va a tocar es una que se
 * queda atrás.
 *
 * ## No navega a ningún sitio después de salir
 *
 * Y no es un olvido. Al cerrar sesión, `GuardiaDeSesion` ve que ya no hay y
 * manda a la puerta él solo; un `navigate()` aquí además de eso serían dos
 * caminos para lo mismo, y el día que uno cambie el otro se queda.
 *
 * Es la misma decisión que `AccesoInversionistaPage` toma al entrar: allí
 * tampoco se navega, deja que el `Navigate` del propio componente lo haga.
 */
export function BarraDeSesion() {
  const { t } = useI18n();
  const { usuario, cerrarSesion } = useSesion();
  const [saliendo, setSaliendo] = useState(false);

  const salir = useCallback(() => {
    // Se bloquea mientras tanto: `cerrarSesion` toca `localStorage` y es
    // rapidisimo, pero dos clics seguidos lanzarian dos cierres y el segundo
    // correria sobre una sesion que ya no existe.
    setSaliendo(true);
    void cerrarSesion();
  }, [cerrarSesion]);

  if (!usuario) return null;

  return (
    <div className={styles.barraDeSesion}>
      <span className={styles.metricHint}>{t.area.acceso.yaEntraste(usuario.correo)}</span>
      <button
        type="button"
        onClick={salir}
        disabled={saliendo}
        className={buttonClass({ variant: 'ghost', size: 'sm' })}
      >
        {t.area.acceso.cerrarSesion}
      </button>
    </div>
  );
}
